/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.19.0
 * @since 1.19.0
 */
import { createSelector } from 'reselect';

import { inquiryInfoApi } from './store';


/*
* -------------------------------------------
*               Api
* -------------------------------------------
*/

const inquiryInfoApiGeneralSelector = (inquiryId: string) =>
    inquiryInfoApi.endpoints.getInquiryInfoGeneral.select({ inquiryId });

export const inquiryInfoApiChatSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.chat,
);

export const inquiryInfoApiCreateDateSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.createDate,
);

export const inquiryInfoApiCustomerNameSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.contact?.customer?.name ?? '',
);

export const inquiryInfoApiDescriptionSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.description,
);
export const inquiryInfoApiIsInquiryCanBeClosedSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.isInquiryCanBeClosed,
);

export const inquiryInfoApiIsInquiryClosedSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.isInquiryClosed,
);

export const inquiryInfoApiIsShowAnswerBlockSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.isShowAnswerBlock,
);

export const inquiryInfoApiIsShowApproveBlockSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.isShowApproveBlock,
);

export const inquiryInfoApiIsShowCloseInquiryButtonSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.isShowCloseInquiryButton,
);

export const inquiryInfoApiLastActionDateSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.lastActionDate,
);

export const inquiryInfoApiNoteMaxLengthSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.noteMaxLength ?? 2000,
);
export const inquiryInfoApiNotifyMailSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.notifyMail,
);

export const inquiryInfoApiNotifyPhoneSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.notifyPhone,
);

export const inquiryInfoApiReportNoteSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.state?.reportNote,
);

export const inquiryInfoApiServiceTypeSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.serviceType,
);

export const inquiryInfoApiStateIdSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.state?.id ?? -1,
);

export const inquiryInfoApiStateNameSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.state?.name ?? '',
);

export const inquiryInfoApiSubscriberMsisdnSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.subscriber?.msisdn,
);

export const inquiryInfoApiTopicDefSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.topic?.def ?? '',
);

export const inquiryInfoApiVisibleInquiryAttributesSelector = (inquiryId: string) => createSelector(
    inquiryInfoApiGeneralSelector(inquiryId),
    state => state.data?.inquiry?.visibleInquiryAttributes ?? [],
);


